var _circle, _circle2, _circle3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgdotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 15,
    viewBox: "0 0 99 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 7.5,
    r: 7.5,
    fill: "#868686"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 7.5,
    r: 7.5,
    fill: "#868686"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 7.5,
    r: 7.5,
    fill: "#868686"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgdotted);
export default __webpack_public_path__ + "static/media/bgdotted.53e0f5328053ebab7eb6933bfaa341b3.svg";
export { ForwardRef as ReactComponent };